import { call, put, takeEvery } from "redux-saga/effects";
import * as DeliveryAddressActions from "./deliveryaddress.actions";
import DeliveryAddressAPI from "./deliveryaddress.api";
import { DeliveryAddressActionTypes } from "./deliveryaddress.model";
import Swal from "sweetalert2";

export function* handleFetchDeliveryAddress(action) {
    try {
        const response = yield call(
            DeliveryAddressAPI.GetDeliveryAddress,
            action.payload
        );
        yield put(DeliveryAddressActions.getDeliveryAddressSuccess(response));
    } catch (e) {
        yield put(DeliveryAddressActions.getDeliveryAddressFailure(e));
    }
}

export function* handleFetchDeliveryAddressByID(action) {
    try {
        const response = yield call(
            DeliveryAddressAPI.GetDeliveryAddressById,
            action.payload
        );
        yield put(
            DeliveryAddressActions.getDeliveryAddressByIDSuccess(response)
        );
    } catch (e) {
        yield put(DeliveryAddressActions.getDeliveryAddressByIDFailure(e));
    }
}

export function* handleCreateDeliveryAddress(action) {
    try {
        const response = yield call(
            DeliveryAddressAPI.CreateDeliveryAddress,
            action.payload
        );
        yield put(
            DeliveryAddressActions.createDeliveryAddressSuccess(response)
        );
        yield put(DeliveryAddressActions.getDeliveryAddressRequest());
        Swal.fire({
            title: "Saved",
            text: "Your new address is successfully added.",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(DeliveryAddressActions.createDeliveryAddressFailure(e));
    }
}

export function* handleDeleteDeliveryAddress(action) {
    try {
        const response = yield call(
            DeliveryAddressAPI.DeleteDeliveryAddressById,
            action.payload
        );
        yield put(
            DeliveryAddressActions.deleteDeliveryAddressSuccess(response)
        );
        yield put(DeliveryAddressActions.getDeliveryAddressRequest());
        Swal.fire({
            title: "Success",
            text: "Delivery address is deleted. ",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(DeliveryAddressActions.deleteDeliveryAddressFailure(e));
    }
}

export function* handleUpdateDeliveryAddress(action) {
    try {
        const response = yield call(
            DeliveryAddressAPI.UpdateDeliveryAddressById,
            action.payload
        );
        yield put(
            DeliveryAddressActions.updateDeliveryAddressSuccess(response)
        );
        Swal.fire({
            title: "Address successfully updated",
            text: "Selected address is updated successfully.",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
        yield put(DeliveryAddressActions.getDeliveryAddressRequest());
    } catch (e) {
        yield put(DeliveryAddressActions.updateDeliveryAddressFailure(e));
    }
}

export function* DeliveryAddressSaga() {
    yield takeEvery(
        DeliveryAddressActionTypes.FETCH_DELIVERY_ADDRESS_REQUEST,
        handleFetchDeliveryAddress
    );
    yield takeEvery(
        DeliveryAddressActionTypes.FETCH_DELIVERY_ADDRESS_ID_REQUEST,
        handleFetchDeliveryAddressByID
    );
    yield takeEvery(
        DeliveryAddressActionTypes.CREATE_DELIVERY_ADDRESS_REQUEST,
        handleCreateDeliveryAddress
    );
    yield takeEvery(
        DeliveryAddressActionTypes.DELETE_DELIVERY_ADDRESS_REQUEST,
        handleDeleteDeliveryAddress
    );
    yield takeEvery(
        DeliveryAddressActionTypes.UPDATE_DELIVERY_ADDRESS_REQUEST,
        handleUpdateDeliveryAddress
    );
}
